import React, { useMemo } from "react";
import styles from "./index.module.scss";

import { Button } from "antd";
import classNames from "classnames";
import useDeviceType from "Utils/useDeviceType";
import ItemStatus from "./components/ItemStatus";
import {
    CoursewareListItem,
    CourseWareTypeList,
    downloadCourse
} from "API/courseware";
import { isTrue } from "Utils/filter";
import CoursewareInfo from "../CoursewareInfo";
import FileIcon from "../FileIcon";

interface CoursewareItemProps {
    data: CoursewareListItem;
    onClick: () => void;
}

export default function CoursewareItem({ data, onClick }: CoursewareItemProps) {
    const { isMobile } = useDeviceType();

    type keyType = keyof typeof CourseWareTypeList;
    const fileType = useMemo((): string => {
        for (let type of Object.keys(CourseWareTypeList)) {
            if (
                CourseWareTypeList[type as keyType].includes(
                    data?.sourceFileEntity?.fileType?.toLowerCase() || ""
                )
            ) {
                return type;
            }
        }
        return "";
    }, [data]);

    return (
        <div className={styles.root}>
            <div className={styles.main}>
                <div className={classNames(styles.icon)}>
                    <FileIcon ext={data.sourceFileEntity?.fileType || ""} />
                </div>

                <h1 className={styles.title}>
                    <span onClick={onClick}>
                        {data.sourceFileEntity?.fileName}
                    </span>
                    <ItemStatus
                        status={
                            isTrue(data.studyStatusEntity?.studyStatus)
                                ? "done"
                                : "todo"
                        }
                    />
                </h1>
                <div className={styles.info}>
                    <CoursewareInfo data={data} />
                </div>
            </div>

            <div className={styles.buttons}>
                {!isMobile &&
                    fileType !== "video" &&
                    isTrue(data.isDownload) && (
                        <Button
                            type="link"
                            className={classNames(
                                styles.button,
                                styles.download
                            )}
                            onClick={() => downloadCourse(data)}>
                            下载课件
                        </Button>
                    )}

                <Button type="link" className={styles.button} onClick={onClick}>
                    {isTrue(data.studyStatusEntity?.studyStatus)
                        ? "学习回顾"
                        : "前往学习"}
                </Button>
            </div>
        </div>
    );
}
